import {
	createMicrophoneAudioTrack
} from "agora-rtc-react";
import {useEffect, useRef, useCallback} from "react";
import Controls from "./Controls";
import {createRemoteLeaveHandler} from "../../../utils/inAppCallEnd";
import styles from "./AgoraComponent.module.css";
import Spinner from "../../../components/Spinner";
import classes from "./AgoraComponent.module.css";
const microphone = require('../../../assets/microphone.png');
const muteMicrophone = require('../../../assets/mute-microphone.png');

const {useState} = require("react");

const useMicrophoneAudioTrack = createMicrophoneAudioTrack();

export const AudioCall = (props) => {
	const {setInCall, channelName, client, appId, token, onRemoteHangup} = props;
	const [users, setUsers] = useState([]);
	const [start, setStart] = useState(false);
	const [remoteMute, setRemoteMuteAudio] = useState(false);
	const [remoteConnectionState, setRemoteConnectionState] = useState({audio: true, video: true});
	const [remoteAudioTrack, setRemoteAudioTrack] = useState(null);
	const remoteHangupHandledRef = useRef(false);
	// A patient whose app went silent (Agora "ServerTimeOut") gets RECONNECT_GRACE_MS to come back
	// before the call ends; a hang-up still ends it at once.
	const [reconnecting, setReconnecting] = useState(false);
	const finalizeRef = useRef(null);
	const leaveHandlerRef = useRef(null);
	if (!leaveHandlerRef.current) {
		leaveHandlerRef.current = createRemoteLeaveHandler({
			endCall: (reason) => finalizeRef.current?.(reason),
			onReconnecting: setReconnecting,
		});
	}

	const finalizeCallAfterRemoteLeft = useCallback((reason) => {
		if (remoteHangupHandledRef.current) return;
		remoteHangupHandledRef.current = true;
		if (typeof onRemoteHangup === "function") {
			onRemoteHangup(reason || "remote_left");
			return;
		}
		if (typeof setInCall === "function") {
			setInCall(false);
		}
	}, [onRemoteHangup, setInCall]);
	finalizeRef.current = finalizeCallAfterRemoteLeft;

	const {ready, track, error} = useMicrophoneAudioTrack();

	useEffect(() => {
		if (!error) return;
		console.log("agora audio error", error);
	}, [error]);

	useEffect(() => {
		if (!props.onAudioStreamsReady || !track || !remoteAudioTrack) return;
		props.onAudioStreamsReady(track, remoteAudioTrack);
	}, [track, remoteAudioTrack, props.onAudioStreamsReady]);

	const init = async () => {
		client.on("user-joined", () => leaveHandlerRef.current.userBack());
		client.on("user-published", async (user, mediaType) => {
			leaveHandlerRef.current.userBack();
			remoteHangupHandledRef.current = false;
			setRemoteConnectionState((prev) => ({ ...prev, [mediaType]: true }));
			await client.subscribe(user, mediaType);

			setUsers((prev) => {
				const filtered = prev.filter((u) => u.uid !== user.uid);
				return [...filtered, user];
			});
			setRemoteMuteAudio(false);

			if (mediaType === "audio") {
				user.audioTrack?.play();
				setRemoteAudioTrack(user.audioTrack || null);
			}
		});

		client.on("user-unpublished", (user, type) => {
			setRemoteConnectionState((prev) => ({ ...prev, [type]: false }));
			if (type === "audio") {
				setRemoteMuteAudio(true);
				user.audioTrack?.stop();
				setRemoteAudioTrack(null);
				
			}
		});

		client.on("user-left", (user, reason) => {
			user.audioTrack?.stop?.();
			setRemoteConnectionState({audio: false, video: false});
			setUsers((prev) => prev.filter((u) => u.uid !== user.uid));
			setRemoteAudioTrack(null);
			leaveHandlerRef.current.userLeft(reason);
		});

		await client.join(appId, channelName, token, props.account);
		if (track) {
			await client.publish([track]);
			await track.setEnabled(true);
		}
		setStart(true);
	};

	useEffect(() => {
		if (!ready || !track || start) return;
		init().catch((e) => console.log("audio init", e));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ready, track, start, channelName]);

	useEffect(() => {
		return () => {
			leaveHandlerRef.current?.dispose();
			client.removeAllListeners();
			try { track?.stop(); } catch {}
			try { track?.close(); } catch {}
			client.leave().catch(() => {});
		};
	}, [client, track]);

	return (
		<>
			{reconnecting && (
				<div style={{background: "#fff4e5", color: "#8a5300", padding: "6px 12px", borderRadius: 6, margin: "6px 0", fontSize: 13}}>
					Patient reconnecting… the call ends if they don't come back within 45 seconds.
				</div>
			)}
			{ready && track ? (
				<div>
					<div>
						{start && users.length > 0 ? (
							users.map((user) => (
								<div key={user.uid} className={`vid ${styles.video_frame_black}`}>
									<img
										className={classes.icon_image}
										src={remoteConnectionState.audio ? microphone : muteMicrophone}
										alt=""
									/>
								</div>
							))
						) : remoteMute ? (
							<div className={`vid ${styles.video_frame_black}`}>
								<img className={classes.icon_image} src={muteMicrophone} alt="" />
							</div>
						) : (
							<div className={`vid ${styles.video_frame_black}`}>
								<Spinner color="white" isLoading />
							</div>
						)}
					</div>

					<div>
						<Controls
							track={track}
							setStart={setStart}
							setInCall={setInCall}
							client={client}
							type="audioCall"
						/>
					</div>
				</div>
			) : (
				<div className={`vid ${styles.video_frame_black}`}>
					<Spinner color="white" isLoading />
				</div>
			)}
		</>
	);
};
